/**
 * @param {Draft.EditorState} editorState
 */
export function getSelectionCollapseInfo(editorState) {
	const content = editorState.getCurrentContent();
	const selection = editorState.getSelection();

	if (!selection.isCollapsed()) return {
		isAtFirstBlock: false,
		isAtLastBlock: false,
		isAtStartOfBlock: false,
		isAtEndOfBlock: false,
	};

	const key = selection.getEndKey();
	const block = content.getBlockMap().get(key);
	const isAtFirstBlock = block === content.getFirstBlock();
	const isAtLastBlock = block === content.getLastBlock();
	const isAtStartOfBlock = selection.getStartOffset() === 0;
	const isAtEndOfBlock = selection.getEndOffset() === block.getLength();

	return {
		block,
		isAtFirstBlock,
		isAtLastBlock,
		isAtStartOfBlock,
		isAtEndOfBlock,
	};
};



// WEBPACK FOOTER //
// ./lib/helpers/selectionUtils.js